import Loadable from 'app/components/Loadable';
import { lazy } from 'react';
import { authRoles } from '../../auth/authRoles';

const CategoryList = Loadable(lazy(() => import('./Qrlist')));
const AddCategory = Loadable(lazy(() => import('./Addqr')));

const QrRoutes = [
	{
		path: '/dashboard/qrlist',
		element: <CategoryList />,
		auth: authRoles.admin,
	},
	{
		path: '/dashboard/addqr',
		element: <AddCategory />,
		auth: authRoles.admin,
	},
];

export default QrRoutes;
